import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as Close } from '../../assets/icons/trvto_closeWhite.svg';
import styles from './BookingSheet.module.css';

/*
 * The popup used for "select travellers" on the activity / guide pages,
 * as a reusable component: dark blurred overlay, centered card on
 * desktop, bottom sheet on mobile. Click outside or ✕ to close.
 *
 *   <BookingSheet open={show} onClose={() => setShow(false)}>
 *       ...content (e.g. the ts-* layout from noPeopleSelect.css)
 *   </BookingSheet>
 */
export default function BookingSheet({ open, onClose, children }) {
    // no page scroll behind the popup
    useEffect(() => {
        if (!open) return undefined;
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previous;
        };
    }, [open]);

    if (!open) return null;

    return createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <Close width={30} height={30} className={styles.close} />
            <div className={styles.sheet} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>,
        document.body
    );
}
